import { Container, containerClasses, Grid } from '@mui/material';
import { AlgoliaHit } from 'instantsearch.js';
import { useHits } from 'react-instantsearch';
import { useTranslation } from 'react-i18next';
import { SupplierHit } from '../search';
import EmptyPagePlaceholder from '../../common/components/EmptyPagePlaceholder';
import GuitaristButterflyImage from '../../assets/images/guitarist_butterfly.png';
import SearchBuyerHit from './SearchBuyerHit';

export default function SearchBuyerHits(): React.JSX.Element {
  const { items, results } = useHits<AlgoliaHit<SupplierHit>>();
  const { t } = useTranslation(['catalogs']);

  return (
    <>
      {!!results && (
        <Container
          maxWidth="xl"
          sx={{
            // The selector is here is used to increase the specifity.
            [`&.${containerClasses.maxWidthXl}`]: {
              px: {
                xs: 1,
                sm: 0,
              },
            },
          }}
        >
          <Grid container columnSpacing={2}>
            {items.map((item) => (
              <Grid key={item.objectID} size={{ xs: 12, sm: 6, md: 4, lg: 3, xl: 2.4 }}>
                <SearchBuyerHit hit={item} />
              </Grid>
            ))}
          </Grid>
        </Container>
      )}
      {!items.length && (<EmptyPagePlaceholder title={t('catalogs:no_store')} imageSrc={GuitaristButterflyImage} />)}
    </>
  );
}
